import { parseSubjectToPerson } from '~/domains/platform/infra/deus-ex-machina/helpers/subject-to-person'
import { type Person, type Subject } from '~/domains/platform/infra/deus-ex-machina/types'

export function entitiesListFactory({
  organizations,
  subject,
  users
}: {
  organizations?: Person[]
  subject: Subject
  users?: Person[]
}) {
  if (subject?.stoneAccounts) return subject.stoneAccounts

  let list: Person[] = [...(organizations ?? [])]

  const roles = subject?.unsafe?.roles

  if (roles?.acquirer || roles?.banking) {
    list = list.concat([parseSubjectToPerson(subject)])
  }

  list = list.concat([...(users ?? [])].filter(entity => entity.roles.banking || entity.roles.acquirer))

  return list
}
